import { React, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Home from "./Home";
import How from "./How"
import AboutUs from "./AboutUs";
import Contact from "./Contact";
import Currencies from "./Currencies";
import Dashboard from "../App/App-Pages/Dashboard";
import Login from "../App/Auth/Login";
import ProtectedRoute from "../App/Auth/AuthGuard";
import Signup from "../App/Auth/Signup";
import OTP from "../App/Auth/OTP";
import Onboarding from "../App/Auth/Username";
import Deposits from "../App/App-Pages/Deposits";
import Widthdrawals from "../App/App-Pages/Widthdrawals";
import Transactions from "../App/App-Pages/Transactions";
import Investments from "../App/App-Pages/Investments";
import PendingDeposits from "../App/App-Pages/PendingDeposits";
import Reset from "../App/Auth/Reset";
import NotFound from "./NotFound";
import Kyc from "../App/Auth/Kyc";
import User from "../App/App-Pages/Profile";
import Market from "../App/App-Pages/Market";
import Users from "../App/App-Pages/Users";
import CopyTrades from "../App/App-Pages/CopyTrades";
import AdminRoute from "../App/Auth/AdminGuard";
import PendingApproval from "../App/Auth/PendingApproval";
import AdminKycReview from "../App/App-Pages/AdminKycReview";
import AdminWallets from "../App/App-Pages/AdminWallets";

function AnimatedRoutes() {

    const location = useLocation();

    useEffect(() => {
      // Scroll to the top when the route changes
      window.scrollTo(0, 0);
    }, [location.pathname]);



  return (
    <AnimatePresence>
      <Routes location={location} key={location.pathname}>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/currencies" element={<Currencies />} />
      <Route path="/how-it-works" element={<How />} />
      <Route path="*" element={<NotFound />} />

      {/* app */}
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/verify-account" element={<OTP />} />
      <Route path="/verify-account/username" element={<Onboarding />} />
      <Route path="/verify-account/kyc" element={<Kyc />}/>
      <Route path="/verify-account/pendingApproval" element={<PendingApproval />}/>
       <Route path="/reset" element={<Reset />}/>

      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>  } />
      <Route path="/deposits" element={<ProtectedRoute> <Deposits /> </ProtectedRoute>} />
       <Route path="/withdrawals" element={<ProtectedRoute><Widthdrawals /></ProtectedRoute>  } />
      <Route path="/transactions" element={<ProtectedRoute ><Transactions /></ProtectedRoute> } />
       <Route path="/trades" element={<ProtectedRoute><Investments /> </ProtectedRoute> } />
       <Route path="/user" element={<ProtectedRoute><User /></ProtectedRoute> }/>
       <Route path="/market" element={<ProtectedRoute><Market /></ProtectedRoute> }/>
       <Route path="adminKycReview" element={<AdminKycReview />}/>
       <Route path="/admin-wallets" element={<AdminWallets />} />


       <Route path="/all-users" element={<AdminRoute> <Users /></AdminRoute>}/>
      <Route path="/pendingDeposits" element={<AdminRoute> <PendingDeposits /> </AdminRoute>} />
      <Route path="/copytrades" element={<AdminRoute><CopyTrades /></AdminRoute>}/>
      <Route path="/adminKycReview" element={<AdminRoute><AdminKycReview /></AdminRoute>} />
      <Route path="/admin-wallets" element={<AdminRoute><AdminWallets /></AdminRoute>} />

        </Routes>
    </AnimatePresence>
  )
}

export default AnimatedRoutes